import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  getApprovedAzureRegionOptions,
  getAzureRegionName,
} from '@internal/azure-regions';

export const RegionPicker = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => {
  const options = getApprovedAzureRegionOptions();

  const handleChange = (event: any) => {
    onChange(event.target.value || '');
  };

  return (
    <FormControl
      fullWidth
      margin="normal"
      required={required}
      error={rawErrors && rawErrors.length > 0}
    >
      <InputLabel id="azure-region-select-label">Region</InputLabel>
      <Select
        labelId="azure-region-select-label"
        id="azure-region-select"
        value={formData || ''}
        onChange={handleChange}
        displayEmpty
      >
        <MenuItem value="">
          <em>Select a region...</em>
        </MenuItem>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {rawErrors && rawErrors.length > 0
          ? rawErrors.map((err: any) => err.stack).join(', ')
          : getAzureRegionName(formData || '') ||
            'Select an approved Azure region'}
      </FormHelperText>
    </FormControl>
  );
};
